module.exports = __webpack_public_path__ + "img/detail-directions.485fa8b1.svg";